import { create } from 'zustand';
import { SearchQuestionItem, searchQuestionService } from '@mygpt/app/chat/services';

interface QuestionSuggestionState {
  loading: boolean;
  questionSuggestions: SearchQuestionItem[];
  searchPromise: Promise<void> | null;
  searchQuestion: (params: Parameters<typeof searchQuestionService>[0]) => Promise<void>;
  clear: () => void;
  waitForSearch: (maxWaitTime?: number) => Promise<void>;
  searchAndWait: (aiId: string, query: string, maxWaitTime?: number) => Promise<void>;
}

export const useQuestionSuggestion = create<QuestionSuggestionState>((set, get) => ({
  loading: false,
  questionSuggestions: [],
  searchPromise: null,
  searchQuestion: async (params) => {
    const searchPromise = (async () => {
      set({ loading: true });
      try {
        const res = await searchQuestionService(params);
        set({ questionSuggestions: res.data });
      } catch (error) {
        console.error(`searchQuestion error: ${error}`);
      } finally {
        set({ loading: false, searchPromise: null });
      }
    })();

    set({ searchPromise });
    return searchPromise;
  },
  clear: () => set({ questionSuggestions: [], searchPromise: null }),
  waitForSearch: async (maxWaitTime = 1000) => {
    const { searchPromise } = get();
    if (!searchPromise) return;

    try {
      await Promise.race([searchPromise, new Promise<void>((resolve) => setTimeout(resolve, maxWaitTime))]);
    } catch (error) {
      // 忽略错误，确保不会阻塞发送
    }
  },
  searchAndWait: async (aiId: string, query: string, maxWaitTime = 1000) => {
    // 如果查询内容长度小于等于1，不需要搜索
    if (query.trim().length <= 1) {
      return;
    }

    // 触发搜索
    const { searchQuestion } = get();
    await searchQuestion({ aiId, search: query });

    // 等待搜索完成
    const { waitForSearch } = get();
    await waitForSearch(maxWaitTime);
  },
}));
